const wowApp = require('angular').module('wowApp.shop');

wowApp.service('RingCaptchaService', ['Restangular', require('./ringcaptcha-service')]);
wowApp.service('SelfexclusionService', ['$rootScope', '$q', 'Restangular', '$http', require('./selfexclusion-service')]);
wowApp.directive('wowSelfexclusionForm', ['GlobalHeaderPanelService', 'BreakpointsService', '$state', '$timeout', '$q', 'SelfexclusionService', 'GoogleCaptchaService', 'SettingsService', 'RingCaptchaService', require('./selfexclusion-form-directive')]);
wowApp.directive('wowSelfexclusionConfirm', ['$state', 'RingCaptchaService', require('./selfexclusion-confirm-directive')]);
wowApp.directive('wowSelfexclusionError', ['$state', require('./selfexclusion-error-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/selfexclusion/index.js
 **/